import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
] as const;

interface TimezoneSelectorProps {
  timezone: string;
  onChange: (tz: string) => void;
}

export function TimezoneSelector({ timezone, onChange }: TimezoneSelectorProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const friendlyName = TIMEZONE_OPTIONS.find((tz) => tz.value === timezone)?.label ?? timezone;

  const handleChange = (value: string) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className='inline-flex items-center gap-2 text-sm text-gray-500'>
      <span>
        {t('booking.timezone')} {friendlyName}
      </span>
      {isOpen ? (
        <select
          value={timezone}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={() => setIsOpen(false)}
          autoFocus
          className='rounded border border-gray-300 px-2 py-1 text-sm text-gray-700 focus:border-blue-500 focus:outline-none'>
          {TIMEZONE_OPTIONS.map((tz) => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
      ) : (
        <button
          type='button'
          onClick={() => setIsOpen(true)}
          className='text-sm text-blue-600 hover:text-blue-700 hover:underline'>
          {t('booking.timezoneChange')}
        </button>
      )}
    </div>
  );
}
